import { EMEO_SAX_V2 } from "../device-info"
import { FingeringInfo, InstrumentInfo, KeyMap } from 'src/app/model/unc-types';

const DefaultFingerings_Sax_V2: FingeringInfo = {
  "XX0" : 44,                       
  "B:C:D:E:F:LowC:PinkyBb": 45, // A#, Bb
  "B:C:D:E:F:G:LowC:PinkyBb": 46,
  "B:C:D:E:F:G:LowC:PinkyB": 47,
  "B:C:D:E:F:G:LowC": 48,
  "B:C:D:E:F:G:LowC:PinkyCSharp": 49,
  "B:C:D:E:F:G": 50,
  "B:C:D:DSharp:E:F:G": 51,
  "B:C:E:F:G": 52,
  "B:C:F:G": 53,
  "B:C:E:G": 54,
  "B:C:G": 55,
  "B:C:E:F:G:PinkyGSharp": 56,
  "B:C": 57,
  "B:BFlat": 58,
  "B:C:PalmBFlat": 58,
  "B": 59,
  "C": 60,
  "": 61,
  "B:C:D:E:F:G:Octave": 62,
  "B:C:D:DSharp:E:F:G:Octave": 63,
  "B:C:E:F:G:Octave": 64,
  "B:C:F:G:Octave": 65,
  "B:C:E:G:Octave": 66,
  "B:C:G:Octave": 67,
  "B:C:G:Octave:PinkyGSharp": 68,
  "B:C:Octave": 69,
  "B:BFlat:Octave": 70,
  "B:C:PalmBFlat:Octave": 70,  
  "B:Octave": 71,
  "C:Octave": 72,
  "Octave": 73,
  "HighD:Octave": 74,
  "HighEFlat:Octave": 75,
  "HighF:Octave": 76,
  "HighD:HighE:HighEFlat:HighF:Octave": 77,
  "HighD:HighE:HighEFlat:HighF:AddtlFSharp:Octave": 78,                      // fis’’’/ges’’’
  "B:D:F:G:Octave:PalmBFlat": 79,
  "B:D:F:G:Octave:PalmC": 80,
  "B:C:G:Octave:PalmC": 81,
  "C:G:HighD:Octave": 82,
  "PalmC:Octave:G": 83, // ais'''
}

/*
&EEPROMTABLE.OPAMP_REF.B_low,13

&EEPROMTABLE.OPAMP_REF.B_,5
&EEPROMTABLE.OPAMP_REF.E_F_sharp,20
&EEPROMTABLE.OPAMP_REF.F_high,0
&EEPROMTABLE.OPAMP_REF.E_high_palm,3
&EEPROMTABLE.OPAMP_REF.F_high_add,6
&EEPROMTABLE.OPAMP_REF.F_sharp_add,16
&EEPROMTABLE.OPAMP_REF.C_palm,4
&EEPROMTABLE.OPAMP_REF.Eb_high_D_sharp, 2
&EEPROMTABLE.OPAMP_REF.Octave,1
&EEPROMTABLE.OPAMP_REF.D_high,7
&EEPROMTABLE.OPAMP_REF.G_sharp,15
&EEPROMTABLE.OPAMP_REF.C_,8
&EEPROMTABLE.OPAMP_REF.Eb_low_D_sharp,17
&EEPROMTABLE.OPAMP_REF.C_sharp,14
&EEPROMTABLE.OPAMP_REF.D_,18
&EEPROMTABLE.OPAMP_REF.C_low,19
&EEPROMTABLE.OPAMP_REF.F_,21
&EEPROMTABLE.OPAMP_REF.Bb_palm,11
&EEPROMTABLE.OPAMP_REF.Bb_low,10
&EEPROMTABLE.OPAMP_REF.Bb_add,9
*/

const KeyMap_Sax_V2: KeyMap = {
  0: { name: 'PalmC', active: true, sensor: 4 },
  1: { name: 'Octave', active: false, sensor: 1 },
  2: { name: 'HighD', active: true, sensor: 7 },
  3: { name: 'HighEFlat', active: true, sensor: 2 },
  4: { name: 'AddtlFSharp', active: true, sensor: 16 },
  5: { name: 'PalmBFlat', active: true, sensor: 11 },
  6: { name: 'F', active: false, sensor: 21 },
  7: { name: 'PinkyCSharp', active: false, sensor: 14, connectedKeys: [ 'PinkyGSharp' ] },
  8: { name: 'D', active: false, sensor: 18 },
  9: { name: 'LowC', active: false, sensor: 19 },
  10: { name: 'E', active: false, sensor: 20 },
  11: { name: 'DSharp', active: true, sensor: 17 },
  12: { name: 'G', active: false, sensor: 12 },
  13: { name: 'PinkyGSharp', active: true, sensor: 15 },
  14: { name: 'AddtlHighF', active: false, connectedKeys: [ 'HighF', 'B' ], sensor: 6 },
  15: { name: 'B', active: false, sensor: 15 },
  16: { name: 'BFlat', active: false, sensor: 9 },
  17: { name: 'C', active: false, sensor: 8, connectedKeys: [ 'BFlat' ] },
  18: { name: 'HighE', active: true, sensor: 3 },
  19: { name: 'HighF', active: true, sensor: 0 },
  20: { name: 'PinkyB', active: false, sensor: 13, connectedKeys: [ 'PinkyGSharp' ] }, 
  21: { name: 'PinkyBb', active: false, sensor: 10, connectedKeys: [ 'PinkyGSharp', 'PinkyB' ] },
  22: { name: 'Dunno', active: false, sensor: 22 },
}

export const EMEO_SAX_V2_INFO : InstrumentInfo = {

  name: "EMEO Digital Saxophone MS",

  description: "EMEO Digital Saxophone with MIDI output and sounds on board.",

  hardware: EMEO_SAX_V2,

  keyMap: KeyMap_Sax_V2,

  defaultFingerings: DefaultFingerings_Sax_V2,

  devices: [ EMEO_SAX_V2 ],

  hidden: false,

}